import { render, staticRenderFns } from "./itemPanel.vue?vue&type=template&id=16e8ba93&scoped=true&"
import script from "./itemPanel.vue?vue&type=script&lang=js&"
export * from "./itemPanel.vue?vue&type=script&lang=js&"
import style0 from "./itemPanel.vue?vue&type=style&index=0&id=16e8ba93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e8ba93",
  null
  
)

export default component.exports